import styles from './ProductSystemsCatalogCell.scss';

import cx from 'classnames';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { GridDirection } from '@material-ui/core/Grid';
import { ImageAlignment, ProductSystemsItems } from 'src/api/contentful/contentTypes.cloverdotcom';
import { GridContainer } from 'src/components/GridContainer/GridContainer';
import { useDesktopOrLarge } from 'src/hooks/UseResponsive';
import { FlatEntry } from 'src/services/cms/flattenContentful';
import { ProductSystemsCatalogImage } from './ProductSystemsCatalogCellImage';
import { ProductSystemsCatalogItems } from './ProductSystemsCatalogCellItems';
interface ProductSystemsCatalogCellProps extends React.HTMLAttributes<HTMLDivElement> {
  entry?: FlatEntry<ProductSystemsItems>;
}

export const ProductSystemsCatalogCell: FC<ProductSystemsCatalogCellProps> = ({
  entry,
}) => {
  if (!entry) return null;
  const isDesktopOrLarge = useDesktopOrLarge();
  const { t } = useTranslation();

  const { imageAlignment } = entry;
  const direction = getFlexDirection(imageAlignment, isDesktopOrLarge);

  const containerClasses = cx(
    styles.productSystemsCatalogCellGrid,
    {
      [styles.productSystemsCatalogCellImageRight]: imageAlignment === ImageAlignment.RIGHT,
    }
  );

  return (
    <div className={styles.productSystemsCatalogCell} aria-label={t('product-system-catalog.details')}>
      <GridContainer justifyContent="center" direction={direction} className={containerClasses} data-test="product-catalog">
        <ProductSystemsCatalogImage entry={entry} />
        <ProductSystemsCatalogItems entry={entry} />
      </GridContainer>
    </div>
  );
};

ProductSystemsCatalogCell.displayName = 'ProductSystemsCatalogCell';

const getFlexDirection = (
  imageAlignment?: ImageAlignment,
  isDesktopOrLarge?: boolean
): GridDirection => {
  if (isDesktopOrLarge && imageAlignment === ImageAlignment.RIGHT) return 'row-reverse';
  return 'row';
};
